import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  show(): void {}
  hide(): void {}
  reset(): void {}
}
